import FieldDefs from './KeysFieldDefs';
import {doLangFields, isGoogleGny} from '../../lib/ks-tools';
import CompareKeysGny from "./CompareKeysGny";
import CompareBacklinksDefs from './CompareBacklinksDefs';

const VIEW_TYPE_BACKLINKS = 'backlinks';

export default {
    template: `<div><slot v-bind="self"/></div>`,
    props: {
        view: {
            required: true
        }
    },
    data() {
        return {
            fields: doLangFields(
                this,
                "lang.tools.site_compare.fields",
                this.view === VIEW_TYPE_BACKLINKS
                    ? CompareBacklinksDefs
                    : (isGoogleGny() ? CompareKeysGny : FieldDefs)
            ),
            sortOrder: [],
            moreParams: {},
        }
    },
    created() {
        this.sortOrder = (
            this.view === VIEW_TYPE_BACKLINKS
                ? [{
                    field: 'numurl',
                    direction: 'desc',
                }]
                : [{
                    field: window.report_db.engine === "yandex" ? 'wsk' : 'ws',
                    direction: 'desc'
                }]
        );
    },
    computed: {
        self() {
            return this;
        },
    },
}
